<template>
	<!-- 我的团队页面 -->
	<div class="team_wrap">
		<!-- 顶部导航栏 -->
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('index.invite') }}</div>
		</div>

		<!-- 佣金卡片 -->
		<div class="commission_card">
			<div class="commission_label">{{ $t('share.commission') }}</div>
			<div class="commission_amount">{{ data.reward }}</div>
			<div class="team_stats">
				<div class="stat_item">
					<div class="stat_value">{{ countTeam }}</div>
					<div class="stat_label">认购人数</div>
				</div>
				<div class="stat_item">
					<div class="stat_value">{{ data.rengou }}</div>
					<!-- <div class="stat_label">{{ $t('share.recharge') }}</div> -->
					<div class="stat_label">认购数量</div>
				</div>
			</div>
		</div>

		<!-- 二维码和分享链接 -->
		<div class="share_card">
			<div class="qrcode_box">
				<img class="qrcode" :src="data.share_image_url" alt="" />
			</div>
			<div class="share_link">
				<div class="link_label">{{ $t('share.shareLink') }}</div>
				<div class="link_content">
					<div class="link_text">{{ data.share_link }}</div>
					<div class="copy_btn" v-clipboard="() => data.share_link" v-clipboard:success="copy">
						{{ $t('invest_bank.copy') }}
					</div>
				</div>
			</div>
		</div>

		<!-- 团队等级标题 -->
		<div class="level_title">
			<!-- {{ $t('share.level1') }}({{ countTop1 }}) -->
			我的朋友({{ countTop1 }})
		</div>

		<!-- 团队列表 -->
		<div class="team_list">
			<!-- 空状态 -->
			<van-empty :description="$t('item.noData')" v-if="listLength" />

			<!-- 列表内容 -->
			<div class="list_content" v-else>
				<div class="list_item" v-for="(item, index) in teamList" :key="index">
					<div class="item_icon">
						<van-icon name="friends-o" />
					</div>
					<div class="item_info">
						<div class="item_phone">{{ item.phone }}</div>
						<div class="item_time">{{ item.time }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * 我的团队页面组件
 * 显示团队成员列表、佣金信息和分享功能
 */
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Empty, Icon } from 'vant';
import Clipboard from "v-clipboard";

Vue.use(Empty).use(Icon).use(Clipboard);

export default {
	name: "myTeam",
	/**
	 * 组件数据
	 * @returns {Object} 数据对象
	 * @returns {Object} data - 团队数据
	 * @returns {number} countTeam - 团队总人数
	 * @returns {number} countTop1 - 一级团队人数
	 * @returns {number} countTop2 - 二级团队人数
	 * @returns {number} countTop3 - 三级团队人数
	 * @returns {number} active - 当前激活的等级
	 * @returns {Array} teamList - 当前显示的团队列表
	 * @returns {boolean} listLength - 列表是否为空
	 */
	data() {
		return {
			data: {},
			countTeam: 0,
			countTop1: 0,
			teamList: [],
			listLength: true
		};
	},
	created() {
		this.$parent.footer('user', false);
	},
	mounted() {
		this.loadData();
	},
	methods: {
		/**
		 * 加载团队数据
		 * 获取团队成员列表和统计信息
		 */
		loadData() {
			Fetch('/user/myTeam').then((r) => {
				this.data = r.data;
				this.teamList = r.data.top1 || [];
				this.listLength = this.teamList.length === 0;
				this.countTop1 = this.teamList.length;
				this.countTeam = this.countTop1;
			});
		},
		/**
		 * 复制成功回调
		 * 显示复制成功提示
		 */
		copy() {
			this.$toast({
				className: "toastName",
				message: this.$t('invest_qrcode.copySucceeded'),
			});
		}
	}
};
</script>

<style lang="less" scoped>
/**
 * 我的团队页面样式
 * 采用卡片式设计，与其他页面保持一致的视觉风格
 */
.team_wrap {
	min-height: 100vh;
	background-color: #f5f5f5;
	padding-bottom: 20px;
}

/* 顶部背景 */
.red_top_bg {
	height: 168px;
	background-image: url(../images/user/moneybag/bg.png);
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 10;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

/* 佣金卡片 */
.commission_card {
	position: relative;
	margin-top: 74px;
	margin-left: 15px;
	margin-right: 15px;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
	border-radius: 12px;
	padding: 25px 20px;
	box-shadow: 0 4px 15px rgba(255, 82, 82, 0.3);
	z-index: 11;

	.commission_label {
		font-size: 14px;
		color: rgba(255, 255, 255, 0.9);
		margin-bottom: 10px;
		text-align: center;
	}

	.commission_amount {
		font-size: 36px;
		font-weight: bold;
		color: #fff;
		text-align: center;
		text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;
	}

	.team_stats {
		display: flex;
		justify-content: center;
		background: rgba(255, 255, 255, 0.2);
		border-radius: 8px;
		padding: 15px 0;

		.stat_item {
			flex: 1;
			text-align: center;
			border-right: 1px solid rgba(255, 255, 255, 0.3);

			&:last-child {
				border-right: none;
			}

			.stat_value {
				font-size: 20px;
				font-weight: 600;
				color: #fff;
				margin-bottom: 4px;
			}

			.stat_label {
				font-size: 12px;
				color: rgba(255, 255, 255, 0.8);
			}
		}
	}
}

/* 分享卡片 */
.share_card {
	margin: 20px 15px;
	background: #fff;
	border-radius: 12px;
	padding: 20px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

	.qrcode_box {
		width: 150px;
		height: 150px;
		margin: 0 auto 20px;
		padding: 8px;
		background: #fff;
		border: 2px solid #f0f0f0;
		border-radius: 8px;

		.qrcode {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	.share_link {
		.link_label {
			font-size: 13px;
			color: #999;
			margin-bottom: 10px;
		}

		.link_content {
			display: flex;
			align-items: center;
			background: #f5f5f5;
			border-radius: 8px;
			padding: 12px;

			.link_text {
				flex: 1;
				font-size: 13px;
				color: #333;
				word-break: break-all;
				margin-right: 10px;
			}

			.copy_btn {
				padding: 8px 16px;
				background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
				color: #fff;
				font-size: 13px;
				border-radius: 20px;
				cursor: pointer;
				white-space: nowrap;
				transition: all 0.3s ease;

				&:active {
					transform: scale(0.95);
				}
			}
		}
	}
}

/* 等级标题 */
.level_title {
	margin: 20px 15px;
	padding: 16px 20px;
	background: #fff;
	border-radius: 10px;
	font-size: 16px;
	font-weight: 600;
	color: #333;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

/* 团队列表 */
.team_list {
	margin: 20px 15px;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	overflow: hidden;

	.list_content {
		.list_item {
			display: flex;
			align-items: center;
			padding: 16px 20px;
			border-bottom: 1px solid #f5f5f5;
			transition: background 0.2s;

			&:last-child {
				border-bottom: none;
			}

			&:hover {
				background: #f9f9f9;
			}

			.item_icon {
				width: 40px;
				height: 40px;
				border-radius: 50%;
				background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
				display: flex;
				align-items: center;
				justify-content: center;
				margin-right: 15px;

				.van-icon {
					font-size: 20px;
					color: #fff;
				}
			}

			.item_info {
				flex: 1;

				.item_phone {
					font-size: 15px;
					color: #333;
					font-weight: 500;
					margin-bottom: 4px;
				}

				.item_time {
					font-size: 12px;
					color: #999;
				}
			}
		}
	}
}
</style>
